import { render, staticRenderFns } from "./PhotoSwipe.vue?vue&type=template&id=f9c88eca&scoped=true&"
import script from "./PhotoSwipe.vue?vue&type=script&lang=js&"
export * from "./PhotoSwipe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c88eca",
  null
  
)

export default component.exports